"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeOfEditorialListPropertyOption = exports.isTypeOfEditorialListProperty = exports.typeOfEditorialListPropertyDefinition = void 0;
const typeOfEditorialListPropertyOptions = ['custom', 'playlist'];
exports.typeOfEditorialListPropertyDefinition = {
    view: { label: 'Type of Editorial List' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: typeOfEditorialListPropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'type-of-editorial-list',
};
const isTypeOfEditorialListProperty = (prop) => {
    return prop.name === exports.typeOfEditorialListPropertyDefinition.name;
};
exports.isTypeOfEditorialListProperty = isTypeOfEditorialListProperty;
const isTypeOfEditorialListPropertyOption = (option) => {
    return typeOfEditorialListPropertyOptions.includes(option);
};
exports.isTypeOfEditorialListPropertyOption = isTypeOfEditorialListPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1vZi1lZGl0b3JpYWwtbGlzdC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3R5cGUtb2YtZWRpdG9yaWFsLWxpc3QucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBTSxrQ0FBa0MsR0FBRyxDQUFDLFFBQVEsRUFBRSxVQUFVLENBQVUsQ0FBQTtBQUU3RCxRQUFBLHFDQUFxQyxHQUFHO0lBQ25ELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSx3QkFBd0IsRUFBRTtJQUN6QyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLGtDQUFrQztTQUM3QztLQUNGO0lBQ0QsSUFBSSxFQUFFLFFBQVE7SUFDZCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSx3QkFBd0I7Q0FDQyxDQUFBO0FBSTFCLE1BQU0sNkJBQTZCLEdBQUcsQ0FBQyxJQUFrQixFQUF1QyxFQUFFO0lBQ3ZHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw2Q0FBcUMsQ0FBQyxJQUFJLENBQUE7QUFDakUsQ0FBQyxDQUFBO0FBRlksUUFBQSw2QkFBNkIsaUNBRXpDO0FBSU0sTUFBTSxtQ0FBbUMsR0FBRyxDQUFDLE1BQWMsRUFBK0MsRUFBRTtJQUNqSCxPQUFRLGtDQUF3RCxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUNuRixDQUFDLENBQUE7QUFGWSxRQUFBLG1DQUFtQyx1Q0FFL0MifQ==